import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectEmail } from '../../../redux/slice/authSlice';
import './adminOnlyRoute.scss';

const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
const AdminOnlyRoute = ({ children }) => {
  const userEmail = useSelector(selectEmail);
   
   if (userEmail && userEmail === ADMIN_EMAIL) {
   return children;
  }

  
    return (
    <section style={{ height: "80vh" }}>
      <div className="permission-denied"> 
        <h2>Permission Denied.</h2>
        <p>This page can only be viewed by an Admin user.</p>
        <br />
        <Link to="/">
          <button className="--btn">&larr; Back To Home</button>
        </Link>
      </div>
    </section>
  );
  
};

export const AdminOnlyLink = ({ children }) => {
  const userEmail = useSelector(selectEmail);

  if (userEmail === "ghribihanen17@gmail.com") {
    return children;
  }
  return null;
};

export { AdminOnlyRoute };
export default AdminOnlyRoute;